export const dateToUTC = (dateString) => {
    // 0000-00-00 - 'year-month-day'
    const regex1 = /^\d{4}-\d{2}-\d{2}$/;
    // 0000-00-00 00:00:00 - 'year-month-day H:i:s'
    const regex2 = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/;
    if (regex1.test(dateString)) {
        dateString += 'T12:00:00';
        return new Date(dateString);
    }
    //
    if (regex2.test(dateString)) {
        const dateArray = dateString.split(' ');
        dateString = dateArray[0];
        dateString += 'T12:00:00';
    }
    return new Date(dateString);
};

export const commaDelimitedNumber = (params) => {
    return Math.floor(Number(params.value)).toLocaleString('en-US');
};

// Used for the tooltip. To ensure we don't output number.00. The .00 is removed.
export const tooltipRenderer = (
    params,
    title = '',
    contentKey = '',
    contentValue = '',
) => {
    // set Tooltip Title
    let tooltipTitle = '';
    if (false === title) {
        tooltipTitle = '';
    } else if (title) {
        tooltipTitle = title;
    } else if (params.title) {
        tooltipTitle = params.title;
    } else if (params.xName) {
        tooltipTitle = params.xName;
    } else if (params.yName) {
        tooltipTitle = params.yName;
    } else if (params.yKey) {
        tooltipTitle = params.yKey;
    } else if (params.xKey) {
        tooltipTitle = params.xKey;
    }

    //
    let tooltipContentKey = '';
    if (false === contentKey) {
        tooltipContentKey = '';
    } else if (contentKey) {
        tooltipContentKey = contentKey;
    } else if (undefined !== params.datum[params.xKey]) {
        if (typeof params.datum[params.xKey] !== 'object') {
            tooltipContentKey = params.datum[params.xKey];
        } else if (typeof params.datum[params.xKey] === 'object') {
            tooltipContentKey = params.datum[params.xKey].value;
        }
    }

    //
    let tooltipContentValue = '';
    if (contentValue) {
        tooltipContentValue = contentValue;
    } else if (undefined !== params.datum[params.yKey]) {
        tooltipContentValue = formatNumberAbbreviated(
            params.datum[params.yKey],
        );
    }

    //
    let tooltipContent = '';
    if (tooltipContentKey) {
        tooltipContent += tooltipContentKey;
    }
    if (tooltipContentKey && tooltipContentValue) {
        tooltipContent += `: ${tooltipContentValue}`;
    }
    if (!tooltipContentKey && tooltipContentValue) {
        tooltipContent += tooltipContentValue;
    }

    return {
        title: tooltipTitle,
        content: tooltipContent,
    };
};

export const formatNumberAbbreviated = (value, no_data = false) => {
    let n = value;
    let sign = Math.sign(n); // Get the sign of the number
    n = Math.abs(n); // Take the absolute value for formatting

    if (n < 1e3) {
        return (sign === -1 ? '-' : '') + n;
    }
    if (n >= 1e3 && n < 1e6) {
        return (sign === -1 ? '-' : '') + (+(n / 1e3).toFixed(1) + 'K');
    }
    if (n >= 1e6 && n < 1e9) {
        return (sign === -1 ? '-' : '') + (+(n / 1e6).toFixed(1) + 'M');
    }
    if (n >= 1e9 && n < 1e12) {
        return (sign === -1 ? '-' : '') + (+(n / 1e9).toFixed(1) + 'B');
    }
    if (n >= 1e12) {
        return (sign === -1 ? '-' : '') + (+(n / 1e12).toFixed(1) + 'T');
    }
};

/**
 * A cell renderer function to display a date string value in a grid cell.
 *
 * @param {Object} params - The input parameters.
 * @param {Object} params.data - The data object containing the date_string field.
 * @param {string} params.value - The value to display, if no date_string is available.
 * @returns {string} The date string to display in the cell.
 */
export const gridDateStringValueFormatter = (params) => {
    // Display the date_string value from params.data if available, otherwise use params.value
    return (params.data && params.data.date_string) || params.value;
};

export const getExportFileName = () => {
    const tags = document.getElementsByTagName('h1');
    if (!tags.length) {
        return false;
    }
    return tags[0].innerText;
};

export const exportProcessCellCallback = (params) => {
    if (
        params.column.colId.indexOf('_pct') !== -1 ||
        params.column.colId.indexOf('_rate') !== -1
    ) {
        return (params.value / 100).toFixed(5);
    }
    return params.value;
};
